import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import DeposcoCredentialsStore from '../../../stores/credentials/deposco-credentials-store';

interface IIntegrationProps {
    credentialsStore: DeposcoCredentialsStore,
    vGroup: IValidationGroup,
}

const DeposcoCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {

    return (
        <>
            <FormFieldLine label='Username' required key='username' note='Deposco username'>
                <Input
                    value={credentialsStore.username}
                    onChange={v => credentialsStore.username = v}
                    validationGroup={vGroup}
                    adornment={''}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Password' required key='password' note='Deposco password'>
                <Input
                    value={credentialsStore.password}
                    onChange={v => credentialsStore.password = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Tenant Code' required key='tenantCode' note='Deposco Tenant Code'>
                <Input
                    value={credentialsStore.tenantCode}
                    onChange={v => credentialsStore.tenantCode = v}
                    validationGroup={vGroup}
                    adornment={''}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Business Unit' required key='businessUnit' note='Deposco Business Unit'>
                <Input
                    value={credentialsStore.businessUnit}
                    onChange={v => credentialsStore.businessUnit = v}
                    validationGroup={vGroup}
                    adornment={''}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default DeposcoCredentials;